import { StatusBarProps } from "./types";

// To web now need status bar
export const StatusBar: React.FC<StatusBarProps> = () => {
  return null;
};
